import React from 'react';
import { TextField } from '@mui/material';

interface CpfFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const CpfField: React.FC<CpfFieldProps> = ({ value, onChange, disabled }) => (
  <TextField
    label="CPF da Entidade"
    value={value}
    onChange={onChange}
    placeholder="___.___.___-__"
    inputProps={{ maxLength: 14 }}
    fullWidth
    disabled={disabled}
  />
);

export default CpfField;
